import type { SVGProps } from "react";

export const Transcript = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M18 12H11M13 16H6M8 12H6M18 16H16M7.33333 21H16.6667C18.5335 21 19.4669 21 20.18 20.673C20.8072 20.3854 21.3171 19.9265 21.6367 19.362C22 18.7202 22 17.8802 22 16.2V7.8C22 6.11984 22 5.27976 21.6367 4.63803C21.3171 4.07354 20.8072 3.6146 20.18 3.32698C19.4669 3 18.5335 3 16.6667 3H7.33333C5.46649 3 4.53307 3 3.82003 3.32698C3.19282 3.6146 2.68289 4.07354 2.36331 4.63803C2 5.27976 2 6.11984 2 7.8V16.2C2 17.8802 2 18.7202 2.36331 19.362C2.68289 19.9265 3.19282 20.3854 3.82003 20.673C4.53307 21 5.46649 21 7.33333 21Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
